import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const ReasonItemContainer = styled.div`
  margin-bottom: 20px;

  ${breakpoints.down('xs')} {
    margin-bottom: 0;
    text-align: center;
  }

  img {
    height: 40px;
    width: 40px;
    margin-bottom: 20px;
  }

  h5 {
    margin-bottom: 8px;
  }

  p {
    font-weight: 400;
    line-height: 2.2rem;
  }
`;

export default ReasonItemContainer;
